module.exports = __webpack_public_path__ + "img/gif-welcome-to-pixel-v2.49af3a3d.gif";